import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { applySeo, normalizePath } from "../seo/apply";
import { initAnalytics, trackPageView } from "../analytics";

// Applies route-specific title, description, canonical, robots, Open Graph, Twitter card and JSON-LD.
export default function Seo() {
  const { pathname } = useLocation();
  useEffect(() => {
    applySeo(pathname);
    initAnalytics();
    trackPageView(normalizePath(pathname));
  }, [pathname]);
  return null;
}
